import { render } from "./rotate-device-verticaly.svg?vue&type=template&id=0f12cc68"
const script = {}
script.render = render

export default script